import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";

import { EMPTY, merge, empty, of } from "rxjs";

import { APP_ACTION, SET_ERROR } from "./app.action";
import { openAppModal } from "../page/page.actions";

const appEpic = action$ =>
    action$.pipe(
        ofType(APP_ACTION),
        switchMap(({ payload }) => empty())
    );

const setErrorEpic = action$ =>
    action$.pipe(
        ofType(SET_ERROR),
        switchMap(({ payload }) => {
            const { status, actionType = "" } = payload;
            if (status === 0 && !navigator.onLine) {
                if (actionType) {
                    return of(
                        openAppModal({
                            type: "no-internet",
                            showActionButton: true,
                            actionType,
                        })
                    );
                }

                return of(openAppModal({ type: "no-internet", showActionButton: false }));
            }

            if (status >= 400 && status <= 500) {
                return of(openAppModal({ type: "service-error" }));
            }

            return EMPTY;
        })
    );

export default function AppEpics(action$) {
    return merge(appEpic(action$), setErrorEpic(action$));
}
